import angular from 'angular';
import uiRouter from 'angular-ui-router';
import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import dropdown from 'angular-ui-bootstrap/src/dropdown';
import scheduleKSummaryReportComponent from './schedule-k-summary-report.component';

let scheduleKSummaryReportModule = angular.module('scheduleKSummaryReport', [
  uiRouter,
  datepickerPopup,
  dropdown
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';
  $urlRouterProvider.otherwise('/');

  $stateProvider.state('scheduleKSummaryReport', {
    parent: 'app',
    url: '/admin/reports/scheduleKSummaryReport',
    data: {
      pageHeader: true,
      pageTitle: 'Schedule K Summary Report',
      pageDesc: 'Summarizes billable direct labor hours and rates by employee and labor category for T&M and FFP LOE contracts.',
      breadcrumbLink: 'admin.reports',
      breadcrumbText: 'View All Reports'
    },
    template: '<schedule-k-summary-report></schedule-k-summary-report>'
  });
})

.component('scheduleKSummaryReport', scheduleKSummaryReportComponent);

export default scheduleKSummaryReportModule;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/schedule-k-summary-report/schedule-k-summary-report.js